import { cB, cM } from '../../../_utils/cssr'

export default cB('popover', [
  cM('rtl', `
    direction: rtl;
    text-align: right;
  `)
])
